<template>
    <div>
        <comp-title-dc v-show="titleVisible" back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/home' }">资产总览</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="warn-list">
            <warn-type
                type="持有份额或在途交易"
                :list="commonList"
                v-on:dealWarn="dealWarn"
            ></warn-type>
            <warn-type
                type="定投协议、定转协议或预约申请"
                :list="planList"
                v-on:dealWarn="dealWarn"
            ></warn-type>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import fundApi from "@/api/fund";
import warnType from "@/components/fund/warnType";

export default {
    name: "WarnList",
    components: { warnType },
    mixins: [mixin],
    props: {
        titleVisible: {
            type: Boolean,
            default: true
        },
        showclose: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            commonList: [], // 持有份额或在途交易
            planList: [] // 定投协议、定转协议或预约申请
        };
    },
    mounted() {
        this.getSuitableList();
    },
    methods: {
        // 获取待处理协议列表
        async getSuitableList() {
            if (!this.$cache.getBinded()) {
                return;
            }
            const res = await userApi.getSuitableList();
            if (res.data) {
                this.commonList = [];
                this.planList = [];
                res.data.data.forEach((item) => {
                    if (item.busitype == "0" || item.busitype == "1") {
                        this.commonList.push(item);
                    } else {
                        this.planList.push(item);
                    }
                });

                if (this.commonList.length === 0 && this.planList.length === 0) {
                    this.$emit("close-dialog");
                }
                this.$store.commit("updateSuitableList", res.data.data);
            }
        },
        // 阅读风险警示
        async dealWarn(val) {
            const _this = this;
            if (val) {
                const _data = {
                    serialno: val.serialno,
                    busitype: val.busitype,
                    chgtype: val.chgtype,
                    opertype: val.opertype,
                    fundcode: val.fundcode
                };
                const res = await fundApi.warnProcessHandler(_data);
                if (res.code == 0) {
                    _this.getSuitableList();
                }

                // 判断
                if (this.commonList.length === 0 && this.planList.length === 0 && !this.showclose) {
                    this.$emit("read-risk-all");
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.warn-list {
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
}
.dialog-title {
    font-weight: bold;
    font-size: 20px;
    color: #333333;
}
</style>
